export const API_ERROR = "userView//API_ERROR";
export const SET_WISHES = "userView/SET_WISHES";
export const RESET = "userView/RESET";
export const SET_WISHES_LOADING = "userView/setWishesLoading";
export const SET_WISHES_LAST_PAGE = "userView/LastPageDownloaded";
export const SET_WISHES_HAS_MORE = "userView/setHasMorePages";
export const SET_USER_DETAIL = "userView/setUserDetail";
export const SET_WISH_STATE = "userView/setWishState";
